const scalingFactor = 8;

export const theme = {
  spacing: (value) => value * scalingFactor,
  colors: {
    primary: {
      red: '#E30613',
      // red: '#EC0E00',
      black: '#000000',
      white: '#FFFFFF',
      grey: '#979797',
      green: '#54C93D',
    },
    greyScale: {
      white: '#FFFFFF',
      grey: '#E1E1E1',
      grey1: '#95989A',
      grey2: '#ECEAF1',
      grey3: '#84819A',
      grey4: '#A2A4A1',
      grey5: '#ADADAD',
      grey6: '#979797',
      backgroundGrey: '#F8F6FA',
      black: '#000000',
    },
    light: {
      red: 'rgba(227, 6, 19, 0.7)',
    },
    dark: {
      red: '#C01C49',
    },
  },

  scrollbarStyle: {
    '& > div::-webkit-scrollbar': {
      width: 6,
    },
    '& > div::-webkit-scrollbar-track': {
      background: '#ffffff',
    },
    '& > div::-webkit-scrollbar-thumb': {
      background: 'rgba(149, 152, 154, 0.43)',
      borderRadius: 5,
    },
    '& > div::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(149, 152, 154, 1)',
    },
  },
};
//background: rgba(145, 158, 171, 0.24);
